import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

interface InvalidSessionModalProps {
  show: boolean;
  onLogout: () => void;
  onRetry: () => void;
}

export const InvalidSessionModal: React.FC<InvalidSessionModalProps> = ({ show, onLogout, onRetry }) => {
  const [isRetrying, setIsRetrying] = useState(false);

  const handleRetry = async () => {
    setIsRetrying(true);
    await onRetry();
    setIsRetrying(false);
  };

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      size="sm"
    >
      <Modal.Body>
        <div className="modal-status bg-danger"></div>
        <div className="text-center py-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon mb-3 text-danger icon-lg"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <h3>Neplatné prihlásovacie údaje</h3>
          <div className="text-secondary">
            Vaše prihlásovacie údaje už nie sú platné. Prosím, prihláste sa znova.
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-100 d-flex flex-column gap-2">
          <Button variant="outline-primary" className="btn-pill w-100" onClick={handleRetry} disabled={isRetrying}>
            {isRetrying ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                Skúšam...
              </>
            ) : (
              'Skúsiť znova'
            )}
          </Button>
          <Button variant="danger" className="btn-pill w-100" onClick={onLogout} disabled={isRetrying}>
            Odhlásiť sa
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
